/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React, { createRef, useCallback, useEffect, useState } from 'react';
import { Col, Row, OverlayTrigger } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { nanoid } from 'nanoid';
import { getSurveySampleById } from '../../../../actions/survey.sample.action';
import { getSurveyQuestionBySurveyIdSectionAndQuestionId } from '../../../../actions/survey.action';
import Chart from '../../../../Components/Chart';
import { getSurveyQuestionsCategories } from '../../../../actions/survey.details.action';
import types from '../../../../types';
import validateOnboardingStep from '../../../../constants/validateOnboardingStep';
import benTooltip from '../../../../Components/BenTooltip';
import { postOnBoardingProcess } from '../../../../actions/user.action';
import { ONBOARDING_STEPS } from '../../../../constants/common';
import Question404Dialog from './question.404.dialog';

const SurveyQuestion = ({ question, onSelectedQuestion, sectionId, index }) => {
  const dispatch = useDispatch();
  const storeJwt = useSelector((state) => state.session.jwt);
  const { surveyQuestion, surveyQuestionError } = useSelector((state) => state.surveys);
  const { visualizations, questionsCategories, openedQuestions } = useSelector((state) => state.surveyDetails);
  const [currentQuestion, setCurrentQuestion] = useState(question);
  const { onBoarding } = useSelector((state) => state.users);
  const [categories, setCategories] = useState([]);
  const {
    sample,
    sampleUpdated,
  } = useSelector((state) => state.surveySample);

  const handleQuestionClick = useCallback((questionId) => {
    if (!visualizations || visualizations.length <= 0) return;
    dispatch({
      type: types.reducerTypes.SURVEY_DETAILS_ONLY_OPEN_QUESTIONS,
      payload: {
        questionId: questionId
      },
    });
    if(!questionId) return;
    dispatch(getSurveySampleById(questionId, storeJwt));
    dispatch(
      getSurveyQuestionBySurveyIdSectionAndQuestionId(
        visualizations.contextId,
        sectionId,
        questionId,
        visualizations,
        storeJwt
      )
    );
    const currentQuestionId = questionId || question.relatedQuestionId;
    dispatch(getSurveyQuestionsCategories(currentQuestionId, storeJwt));
    onSelectedQuestion(questionId);
  }, [dispatch, onSelectedQuestion, question.relatedQuestionId, sectionId, storeJwt, visualizations]);

  const updateChartType = (currJob, chartName) => {
    const updatedVisu = { ...visualizations };
    const defaultSettings = {
      benchmarks: {
        state: false,
        national: false,
      },
      showPrincipalResponses: false,
    };
    updatedVisu.details.chartSettings.chartSettings[currJob.id] = {
      ...(updatedVisu?.details?.chartSettings?.chartSettings[currJob.id] || defaultSettings),
      selectedChartType: chartName,
    };
  };

  const updateBenchmark = (currJob, benchmarks) => {
    const updatedVisu = { ...visualizations };
    updatedVisu.details.chartSettings.chartSettings[currJob.id] = {
      benchmarks,
      showPrincipalResponses: false,
      selectedChartType:
        updatedVisu?.details?.chartSettings?.chartSettings[currJob.id]?.selectedChartType ||
        currJob?.defaultVisualizationType,
    };
  };
  useEffect(() => {
    if (surveyQuestion && openedQuestions.includes(question.id)) {
      setCurrentQuestion(surveyQuestion);
      setCategories(questionsCategories);
    } else {
      setCurrentQuestion(question);
      setCategories([]);
    }
  }, [
    surveyQuestion,
    setCurrentQuestion,
    question,
    setCategories,
    questionsCategories,
    openedQuestions
  ]);
  useEffect(() => {
    if (!sampleUpdated || question.id !== sample.Id) return;
    dispatch({ type: types.reducerTypes.SURVEY_SAMPLE_DIMENSION_UPDATED });
    setTimeout(() => {
      handleQuestionClick(question.id);
    }, 2000);
  }, [sample, dispatch, sampleUpdated, question, handleQuestionClick]);

  const saveStepHandler = () => {
    onBoarding.push(ONBOARDING_STEPS.step2.value);
    dispatch(postOnBoardingProcess({ steps: onBoarding }, storeJwt))
  }

  useEffect(() => {
    if (surveyQuestionError) {
      Question404Dialog(dispatch);
    }
  }, [dispatch, surveyQuestionError]);

  return (
    <Row>
      <Col>
        {currentQuestion && (
          <OverlayTrigger
            key={question?.id}
            placement="bottom"
            defaultShow={validateOnboardingStep(ONBOARDING_STEPS.step2.value, ONBOARDING_STEPS.step2.previous, onBoarding) && index === 0}
            show={validateOnboardingStep(ONBOARDING_STEPS.step2.value, ONBOARDING_STEPS.step2.previous, onBoarding) && index === 0}
            overlay={(props) => benTooltip({
              ...props,
              title: ONBOARDING_STEPS.step2.title,
              content: ONBOARDING_STEPS.step2.content,
              close: saveStepHandler
            })}>
            <Chart
              key={nanoid()}
              currentJob={currentQuestion}
              visualization={visualizations || {}}
              currentCategory={categories?.find((qc) => qc?.key_id === currentQuestion?.id)}
              questionsCategories={categories}
              isRelated={!!currentQuestion.relatedQuestionId}
              spaceAdded={false}
              isEditing={true}
              updateChartType={updateChartType}
              updateBenchmark={updateBenchmark}
              onExport={() => { }}
              ref={createRef()}
              onSelectedQuestion={handleQuestionClick}
            />
          </OverlayTrigger>
        )}
      </Col>
    </Row >
  );
};

export default SurveyQuestion;
